export const setElementHeight = (element: HTMLDivElement | null, variable: string): void => {
  if (!element) return;
  const rect = element.getBoundingClientRect();
  document.documentElement.style.setProperty(variable, `${rect.height.toString()}px`);
};
